import { useEffect } from "react";

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from "@/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/analytics/constants";

import { RawRelationships } from "../types";

export const useRelationshipsPageAnalytics = (
    relationships: RawRelationships
) => {
    const { sourceKey, identityAttrs } = useFastshiftAnalyticsData();
    const { fireTrackEvent } = useFireAnalyticsEvents();

    // Track event for relationships section displayed
    useEffect(() => {
        if (!identityAttrs) {
            return;
        }

        const fastshiftRelationships = relationships.map((r) => r.type);
        const hasCustomerFastshiftChampion = relationships.some(
            (r) => r.type === "FAST_SHIFT_CHAMPION"
        );

        fireTrackEvent({
            action: ActionKey.DISPLAYED,
            actionSubject: ActionSubjectKey.SECTION,
            actionSubjectId: ActionSubjectIdKey.FASTSHIFT_RELATIONSHIPS_SECTION,
            source: sourceKey,
            attributes: {
                hasCustomerFastshiftChampion,
                fastshiftRelationships
            }
        });
    }, [fireTrackEvent, identityAttrs, sourceKey, relationships]);
};
